<section class="ref-view">
    <div class="ref-panel">
        <div class="ref-panel-h">
            <div>
                <h2>Payout account verification</h2>
                <p>Bank/UPI destinations are verified separately from identity KYC before any payout can be sent there.</p>
            </div>
        </div>
        <div class="ref-kyc-list">
            <div class="ref-kyc" *ngFor="let p of list">
                <div class="row-x"><b>{{p.referrerName}}</b><span class="ref-pill p-pending">Pending</span></div>
                <div class="row-x"><span>Code</span>{{p.referrerCode}}</div>
                <div class="row-x"><span>Type</span>{{p.type}}</div>
                <div class="row-x"><span>Account holder</span>{{p.accountHolderName}}</div>
                <ng-container *ngIf="p.type === 'BANK'">
                    <div class="row-x"><span>Bank</span>{{p.bankName}}</div>
                    <div class="row-x"><span>Account no.</span>{{p.accountNumberMasked}}</div>
                    <div class="row-x"><span>IFSC</span>{{p.ifsc}}</div>
                </ng-container>
                <div class="row-x" *ngIf="p.type === 'UPI'"><span>UPI ID</span>{{p.upiId}}</div>
                <div class="ref-tools">
                    <button class="btn btn-success btn-sm" type="button" (click)="verify(p)">Verify</button>
                    <button class="btn btn-outline-danger btn-sm" type="button" (click)="reject(p)">Reject</button>
                </div>
            </div>
            <p class="ref-empty" style="grid-column:1/-1" *ngIf="loading">Loading…</p>
            <p class="ref-empty" style="grid-column:1/-1" *ngIf="!loading && !list.length">No payout accounts waiting for verification.</p>
        </div>
    </div>
</section>
